import ProjectLogs from './ProjectLogs';

export default ProjectLogs;


// WEBPACK FOOTER //
// ./resources/assets/js/components/ProjectLogs/index.js